import * as React from "react";

export const IconSuspended = (_props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.6083 0L4.39167 0L0 4.39167L0 10.6083L4.39167 15L10.6083 15L15 10.6083L15 4.39167L10.6083 0ZM11.6667 10.6167L10.6167 11.6667L7.5 8.55L4.38333 11.6667L3.33333 10.6167L6.45 7.5L3.33333 4.38333L4.38333 3.33333L7.5 6.45L10.6167 3.33333L11.6667 4.38333L8.55 7.5L11.6667 10.6167Z" fill="currentColor"/>
  </svg>

);
